import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  formControlContainer: {
    padding: '10px 0px',
    marginLeft: '0px',
    marginRight: '0px',
    borderBottom: '1px solid rgba(44, 45, 62, 0.3)',
    cursor: 'default',

    '& .MuiInput-underline:before': {
      border: 'unset',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      border: 'none',
    },
  },
  attachmentContainer: {
    display: 'inline-flex',
    fontFamily: 'Roboto',
    fontSize: '0.9em',
    alignItems: 'center',
    margin: '5px',
    maxWidth: '700px',
  },
  attachmentsContainer: {
    margin: '5px 0',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    borderTop: '1px solid rgba(44, 45, 62, 0.3)',
    paddingTop: '10px',
    flexShrink: 0,
    width: '100%',
    
    '& .MuiFormGroup-root': {
      flexWrap: 'nowrap',
    },
  },
  subjectInput: {
    paddingLeft: '10px',
    '& input': {
      paddingTop: '25px',
      paddingLeft: '5px'
    },
  },
  messageContentInput: {
    '& textarea': {
      overflowY: 'auto !important',
    },
  },
  replyRecipient: {
    fontSize: '14px',
  },
  recipientsFormControl: {
    margin: '10px 0 10px 10px',
  },
  root: {},
}));
